import Site from "../stores/Site";

export default class Hero {
    constructor(el) {
        this.el = el

        this.initMedia()
        this.initArrowBtn()
    }

    initMedia() {
        if (!Site.isMobile) return

        const hero = Site.page.querySelector('.s-hero')

        if (!hero) return

        const media = hero.querySelector('.hero-media')

        if (media && Site.page.id === 'software-single') {
            media.remove()
        }
    }

    initArrowBtn() {
        const btn = this.el.querySelector('.hero-arrow-btn')

        if (!btn) return

        const nextSection = this.el.nextElementSibling

        btn.addEventListener('click', (e) => {

            e.preventDefault()

            nextSection.scrollIntoView({
                behavior: 'smooth'
            })
        })
    }
}